/**
 * @voltxampere/ui — RP2040 (Raspberry Pi Pico) variant (Sprint 43-5, placeholder)
 *
 * PLACEHOLDER. Full GPIO + ADC + PWM + I2C + SPI + PIO simulation
 * arrives Sprint 46+ (ARM Cortex-M0+ dual-core family).
 *
 * Reference: Raspberry Pi RP2040, QFN-56. ARM Cortex-M0+ dual-core 32-bit.
 * Vcc 1.8-5.5 V VBUS / 1.62-3.63 V IOVDD, fmax 133 MHz, no internal
 * Flash (external QSPI 2 MB on Pico), 264 KB SRAM, 30 GPIO, 4-channel
 * 12-bit ADC, 16 PWM, 2× UART / 2× SPI / 2× I2C, 8× PIO state machines.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const mcuRp2040 = {
    id: "rp2040",
    nameTr: "RP2040 (Raspberry Pi Pico, QFN-56, placeholder)",
    nameEn: "RP2040 (Raspberry Pi Pico, QFN-56, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "RP2040",
    schemaType: "digital-gate",
    defaultParams: {
        gateFunction: "NOT",
        vHigh: 3.3,
        vLow: 0,
        threshold: 1.65,
        propagationDelay: 8e-9,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=mcu-rp2040.js.map